import React, { useEffect, useState } from 'react';
import b_ from 'b_';
import { Card, Button } from 'antd';
import AuthLayout from '../../Components/AuthLayout';
import './styles.scss';
import { AmazonOutlined } from '@ant-design/icons'
import TokenService from '../../Services/TokenService';
import { getDomainUrl } from 'front-end-common/src/utils/envDependent'

const {
  REACT_APP_AUTH_CLIENT_ID: CLIENT_ID,
  REACT_APP_AUTH_URL: AUTH_URL,
  REACT_APP_AUTH_RESPONSE_TYPE: RESPONSE_TYPE,
  REACT_APP_AUTH_SCOPE: SCOPE,
} = process.env;

const REDIRECT_URL = getDomainUrl() + '/redirect'

const url = `${AUTH_URL}/authorize?client_id=${CLIENT_ID}&response_type=${RESPONSE_TYPE}&scope=${SCOPE}&redirect_uri=${REDIRECT_URL}`;
const b = b_.lock('SignIn');

function SignIn() {
  const [sha, setSha] = useState(null);
  useEffect(() => {
      TokenService.generateAndSaveSha256().then(data => {
        setSha(data);
      });
    },
    [],
  );
  

  return <AuthLayout className={b()}>
    <Card className={b('card')} title="Sign In">
      <a className={b('link')}
         href={sha && (url + `&code_challenge_method=S256&code_challenge=${sha}`)}
      >
        <Button type="primary"
                style={{backgroundColor: "#1976d2" }}
                variant="contained"
                size="large"
        >
          <AmazonOutlined /> Sign In with Amazon Cognito
        </Button>
      </a>
    </Card>
  </AuthLayout>;
}

export default SignIn;
